
export const mapResultData = ({ props, isUpdateMode, backgroundId, state }, isSuccessPage, inputIds, inputWithProps) => {
    const { colors, activeBuilderType } = props;

    const resultJson = {
        config: {
            inputs: [],
            settings: {
                textcolor: colors[activeBuilderType].textColor,
                backgroundColor: colors[activeBuilderType].backgroundColor,
                elementColor: colors[activeBuilderType].elementColor,
                backgroundPictureId: backgroundId,
            }
        },
        html: ''
    };

    if (!isSuccessPage) {
        resultJson['formId'] = state.formSlug;
        resultJson['email'] = window.location.href.split('?')[1] || null;
    }

    for (const input of inputIds[activeBuilderType]) {
        const item = inputWithProps.get(input.id);

        if (item) {
            const _item = {...item};
            _item['id'] = String(input.id);
            delete _item._value;
            delete _item._hasValidationErrors;

            resultJson.config.inputs.push(_item);
        }
    }

    return resultJson;
}